import { render } from "./LayoutCallCenter.vue?vue&type=template&id=f2a54e8a&scoped=true"
import script from "./LayoutCallCenter.vue?vue&type=script&lang=js"
export * from "./LayoutCallCenter.vue?vue&type=script&lang=js"

import "./LayoutCallCenter.vue?vue&type=style&index=0&id=f2a54e8a&lang=less&scoped=true"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2a54e8a"]])

export default __exports__